import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer } from "recharts";
import { useNavigate } from 'react-router-dom';
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { ReviewVolumnResponse } from '../../_config/interfaces/interfaces';

const ReviewVolumn = ({ filterValue, onTotalReviewCount, onAverageReviewCount }: { filterValue: any; onTotalReviewCount: (total: number) => void; onAverageReviewCount: (average: number) => void }) => {
    const [reviewVolumn, setReviewVolumn] = useState<ReviewVolumnResponse>({ reviews_by_date: [] });
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);

    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); 
        } else {
            getReviewVolumn({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        // console.log('filterValue =>', filterValue);
        getReviewVolumn(filterValue);
    }

    const getReviewVolumn = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                sentimentAPI.getReviewVolumn(params, (msg: any, resp: any) => {
                    // console.log('response =>', resp, msg);
                    setReviewVolumn(resp.data);
                    onTotalReviewCount(resp?.data?.total_reviews);
                    onAverageReviewCount(resp?.data?.avg_reviews_per_day);
                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                })
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }

    const formatDate = (date: string) => {
        return moment(date).format('DD MMM');
    }

    return (
        reviewVolumn?.reviews_by_date.length > 0 && (<div>
            <ResponsiveContainer width={"100%"} height={300}>
                <AreaChart
                    width={200}
                    height={60}
                    data={reviewVolumn?.reviews_by_date}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5
                    }}
                >
                    <XAxis dataKey="date" tickFormatter={formatDate} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Area type="monotone" dataKey="review_count" stroke="#3B82F680" fill="#3B82F680" />
                </AreaChart>
            </ResponsiveContainer>
        </div>)
    );
}

export default ReviewVolumn;